import { render } from "./InternetStatsModal.vue?vue&type=template&id=0adba79c&scoped=true"
import script from "./InternetStatsModal.vue?vue&type=script&lang=js"
export * from "./InternetStatsModal.vue?vue&type=script&lang=js"

import "./InternetStatsModal.vue?vue&type=style&index=0&id=0adba79c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adba79c"]])

export default __exports__